import React from 'react'

import Menu from '../menu'

import './header.css'

const Header = () => (
  <header className="app-header">
    <span className="app-header__logo"></span>
    <Menu />
  </header>
);

export default Header;
